import { render, staticRenderFns } from "./MobileGeneral.vue?vue&type=template&id=fbecf08c&scoped=true"
import script from "./MobileGeneral.vue?vue&type=script&lang=js"
export * from "./MobileGeneral.vue?vue&type=script&lang=js"
import style0 from "./MobileGeneral.vue?vue&type=style&index=0&id=fbecf08c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbecf08c",
  null
  
)

export default component.exports